export default function Delete({ style, onClick }) {
  return (
    <svg
      className={style}
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      onClick={onClick}
    >
      <circle cx='8' cy='8' r='8' fill='#D93F21' />
      <path
        d='M11.2008 4.80078L4.80078 11.2008'
        stroke='white'
        strokeWidth='1.2'
        strokeLinecap='round'
      />
      <path
        d='M11.2008 11.2008L4.80078 4.80078'
        stroke='white'
        strokeWidth='1.2'
        strokeLinecap='round'
      />
    </svg>
  )
}
